<zn-hierarchical-view
  [rootComponentInstance]="this"
  [hideCreateButton]="true"
  [disableCanDelete]="true"
/>
<app-generic-form
  #genericForm
  (payload)="save($event)"
></app-generic-form>